document.addEventListener('DOMContentLoaded', () => {
  function normalizeText(text) {
    return String(text || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function isSizeOptionName(name) {
    const value = normalizeText(name).toLowerCase();
    return value.includes('tamanho') || value.includes('size');
  }

  function getSelectedSize() {
    const checkedInputs = document.querySelectorAll(
      'variant-picker input[type="radio"]:checked, input[type="radio"][data-option-name]:checked'
    );

    for (const input of checkedInputs) {
      if (isSizeOptionName(input.dataset.optionName || input.name || '')) {
        return normalizeText(input.value);
      }
    }

    const selects = document.querySelectorAll('variant-picker select, select');
    for (const select of selects) {
      const context = normalizeText(
        (select.dataset.optionName || '') + ' ' +
        (select.name || '') + ' ' +
        (select.id || '') + ' ' +
        (select.closest('.variant-option')?.textContent || '') + ' ' +
        (select.closest('label')?.textContent || '')
      ).toLowerCase();

      if (context.includes('tamanho') || context.includes('size')) {
        return normalizeText(select.value);
      }
    }

    return null;
  }

  function getSizeLine(guide, size) {
    guide = normalizeText(guide);
    size = normalizeText(size);
    if (!guide || !size) return null;

    const sizePattern = escapeRegExp(size);
    const sizeToken = '(?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL|5XL|6XL|\\d{2,3})';
    const nextSize = '(?=\\s+' + sizeToken + '(?:\\s*\\/\\s*(?:EUR\\s*)?[^:—–-]+)?\\s*(?:—|–|-|:)|$)';

    const regex = new RegExp(
      '(?:^|\\s)' +
      sizePattern +
      '(?:\\s*\\/\\s*(?:EUR\\s*)?([^:—–-]+))?' +
      '\\s*(?:—|–|-|:)\\s*' +
      '(.+?)' +
      nextSize,
      'i'
    );

    const match = guide.match(regex);
    if (!match) return null;

    const eur = normalizeText(match[1] || '');
    const measures = normalizeText(match[2] || '');
    if (!measures) return null;

    return {
      eur: eur,
      measures: measures
    };
  }

  function updateMeasurement() {
    const size = getSelectedSize();

    document.querySelectorAll('[data-shamar-size-measure]').forEach((output) => {
      const guide = output.dataset.sizeGuide || '';

      if (!guide || !size) {
        output.style.display = 'none';
        return;
      }

      const measurement = getSizeLine(guide, size);
      if (!measurement) {
        output.style.display = 'none';
        return;
      }

      const eurText = measurement.eur ? ' / EUR ' + measurement.eur : '';
      output.textContent =
        'Medidas do tamanho selecionado: ' +
        size +
        eurText +
        ' — ' +
        measurement.measures;

      output.style.display = 'block';
    });
  }

  function preferSizeSOnInitialLoad() {
    const selects = document.querySelectorAll('variant-picker select, select');

    for (const select of selects) {
      const context = normalizeText(
        (select.dataset.optionName || '') + ' ' +
        (select.name || '') + ' ' +
        (select.id || '') + ' ' +
        (select.closest('.variant-option')?.textContent || '') + ' ' +
        (select.closest('label')?.textContent || '')
      ).toLowerCase();

      if (!context.includes('tamanho') && !context.includes('size')) continue;

      const sOption = Array.from(select.options).find(
        (option) => normalizeText(option.value).toUpperCase() === 'S'
      );

      if (sOption && select.value !== sOption.value) {
        select.value = sOption.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  preferSizeSOnInitialLoad();
  setTimeout(preferSizeSOnInitialLoad, 250);
  setTimeout(preferSizeSOnInitialLoad, 750);
  setTimeout(updateMeasurement, 850);

  document.addEventListener('change', (event) => {
    if (event.target.matches('select, input[type="radio"][data-option-name]')) {
      setTimeout(updateMeasurement, 50);
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.variant-option__button-label')) {
      setTimeout(updateMeasurement, 75);
    }
  });
});
